module.exports = __webpack_public_path__ + "static/img/certificado-14001-2015.4656c66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/sistema-de-gestion/certificado-14001-2015.jpg
// module id = nHuZ
// module chunks = 0